import { Currencies } from '@/entities/curency'
import { DisputModel, DisputStatus } from '@/features/orders'
import { formatCurrency, getStorageItem } from '@/shared/lib'
import { TopupModel, TopupModelMerchant } from '../../model'
import { Roles } from '@/entities/roles'
import { USER_ROLE_KEY } from '@/features/auth'

export const DisputAmounts = ({
  disputData,
  topupData,
}: {
  disputData: DisputModel
  topupData: TopupModel | TopupModelMerchant
}) => {
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)
  const subtitleClasses = 'text-text-secondary text-sm md:leading-[18px]'
  const isMerchant = userRole === Roles.Merchant
  const totalAmountUsdt = isMerchant
    ? (topupData as TopupModelMerchant).factAmountTo
    : (disputData?.disputAmountFromTraderUsdt ?? disputData.disputAmountFromMerchantUsdt)

  const totalAmountRub = isMerchant
    ? (topupData as TopupModelMerchant).factAmountFrom
    : (disputData.disputAmountFromTrader ?? disputData.disputAmountFromMerchant)

  return (
    <>
      <div className="flex flex-col items-end px-6 border-r border-l">
        <span className={subtitleClasses}>Сумма спора:</span>
        <span className="text-[24px]">
          {formatCurrency(disputData?.disputAmountFromMerchantUsdt ?? 0, Currencies.USDT)}
        </span>
        <span className={subtitleClasses}>
          {formatCurrency(disputData?.disputAmountFromMerchant ?? 0, Currencies.RUB)}
        </span>
      </div>

      <div className="flex flex-col items-end">
        <span className={subtitleClasses}>Итоговая сумма:</span>
        {disputData?.status === DisputStatus.Satisfied && (
          <>
            <span className="text-[24px]">{formatCurrency(totalAmountUsdt, Currencies.USDT)}</span>
            <span className={`${subtitleClasses}`}>
              {formatCurrency(totalAmountRub, Currencies.RUB)}
            </span>
          </>
        )}
      </div>
    </>
  )
}
